// extracted by mini-css-extract-plugin
module.exports = {"dialog_company_popup":"CompanyPopup_dialog_company_popup_2gjGO","btn_cancel":"CompanyPopup_btn_cancel_2GfmB"};